import React, { Component } from 'react';
import {Grid, Button} from 'semantic-ui-react';
import '../../assets/css/home.css';
import TravelStoriesThumb from "./TravelStoriesThumb.js";
import {Redirect} from 'react-router';
import data from '../../assets/json/home/travelStories.json';
import headerBorder from '../../assets/images/line-orange.png';

class TravelStories extends Component {
	
	constructor(props){
		super(props);
		
		let defaults = this.getDefaults();
		this.state = {
			data: data.travelstories,
			title: defaults.title,
			thumbnail: defaults.thumbnail,
			description: defaults.description,
			days: defaults.days,
			href: defaults.href,
			storyCount: Object.keys(data.travelstories).length,
			redirect:false,
			routeLink: ''
		};

	}
	
	getDefaults = () => {
		let d = data.travelstories;
		return d.filter((item) => item.active === 'true')[0];
	}

	onThumbnailClick = (img, index) => {
		const itemCount = this.state.storyCount;
		let d = this.state.data;
		
		for (var i = 0; i < itemCount; ++i) {
			if(i === index){
				d[i].active = "true";
			}
			else{
				d[i].active = "false";
			}
		}
				
		this.setState({
			title: img.title,
			thumbnail: img.thumbnail,
			description: img.description,
			country:img.country,
			href: img.href,
			data: d,
		});
		
	}

	goToTravel = () => {
		this.setState({
			redirect: true,
			routeLink: '/travelstories'
		});
	}
	
  render() {
		const {redirect, routeLink} = this.state;
		return(
			<div>
				{ redirect &&
					<Redirect push to={routeLink}/>
				}
				<div className="align-center">
					<h1 className="section-header">Travel Stories</h1>
					<img src={headerBorder} className="header-border" alt="" />
					<p className="para-content">Hear more about our patrons' experiences while traveling to their dream destinations with us!
					</p>
				</div>
				<Grid className="tour-details-wrapper travel-stories-content">
					{
						this.state.data.map(
							(img, i) => (
								<Grid.Column
									width={6}
									className= {this.state.data[i].active === "true" ? "thumb-wrapper active" : "thumb-wrapper"} 
									key={i} 
									onClick={() => this.onThumbnailClick(img, i)}>
									<TravelStoriesThumb
										className="thumb"
										index={i}
										name={img.title}
										thumbnail={img.thumbnail}
										description={img.description}
										country={img.country}
										href={img.href}
										data={this.state.data}
									/>
								</Grid.Column>
							)
						)
					}
				</Grid>
				<div className="section-content-wrapper margin-top-2 align-center">
					<Button color='orange' onClick={this.goToTravel}>See more travel stories</Button>
				</div>
			</div>
		);
	}
}

export default TravelStories;